import { Badge, Group, rem, Text, UnstyledButton } from '@mantine/core'
import { COLORS } from '../../utils/constants'

interface NavButtonProps {
  icon?: React.ReactNode
  label: string
  active?: boolean
  badge?: number
  onClick?: () => void
  chevron?: boolean
  isVisible?: boolean
}

const NavButton = ({ icon, label, active, badge, onClick }: NavButtonProps) => (
  <UnstyledButton
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      padding: '8px 12px',
      borderRadius: '4px',
      backgroundColor: active ? COLORS.LightGreen : 'transparent',
      color: '#fff',
      '&:hover': {
        backgroundColor: COLORS.LightGreen,
      },
    }}
  >
    <Group justify='space-between' style={{ flex: 1 }}>
      <Group>
        {icon}
        <Text size='sm' fw={500}>
          {label}
        </Text>
      </Group>
      <Group gap={8}>
        {badge && badge > 0 && (
          <Badge
            size='sm'
            variant='filled'
            color={COLORS.HiddenGemzRed}
            style={{
              minWidth: rem(20),
              height: '20px',
              fontSize: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {badge > 99 ? '99+' : badge}
          </Badge>
        )}
      </Group>
    </Group>
  </UnstyledButton>
)

export default NavButton
